import React, { useState } from 'react'
import cx from 'classnames'
import { FormattedMessage } from 'react-intl'
import { InlineShareButtons } from 'sharethis-reactjs'

const ShareButton = ({ label }) => {
  const [isShareOpen, setIsShareOpen] = useState(false)

  return (
    <div className='flex flex-shrink-0 items-center h-12'>
      <span className='extended mr-2 text-gray-dark whitespace-no-wrap'>
        <FormattedMessage id={label} />
      </span>
      <button
        onClick={() => setIsShareOpen(!isShareOpen)}
        className='font-bold text-xs text-blue uppercase whitespace-no-wrap'
      >
        {isShareOpen ? <FormattedMessage id='close' /> : <FormattedMessage id='share' />}{' '}
        <em className={cx('fas ml-1 text-orange', isShareOpen ? 'fa-times-circle' : 'fa-share')} />
      </button>
      <div className={cx(isShareOpen ? 'block' : 'hidden', 'ml-2')}>
        <InlineShareButtons
          config={{
            alignment: 'center',
            color: 'social',
            enabled: true,
            font_size: 16,
            labels: 'cta',
            language: 'en',
            networks: ['email', 'text', 'pinterest', 'facebook', 'twitter'],
            padding: 8,
            radius: 8,
            show_total: false,
            size: 32
          }}
        />
      </div>
    </div>
  )
}

export default ShareButton
